import React, { useEffect, useState } from 'react';
import { DataTable, ModalPopup, SecondaryButton } from '../../CommonComponent';
import './MiningPartsList.scss';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import ExportexcelComp from '../../CommonComponent/ExportExcel';
import SaveCartPopUp from '../SaveCartPopUp';
import { useSelector } from 'react-redux';
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { selectors as headerSelector } from '../../../state/features/header';
import partsService from '../../../services/partsservice';
import Alerts from '../../Alerts';
import Loader from '../../Loader';
import SharePartList from '../SharePartList';
import { confirmDailog } from '../../ConfirmDailog';
import { IMiningPartsInterface } from './IMiningPartsInterface';


const MiningPartsLists = (props: IMiningPartsInterface) => {

    const { t } = useTranslation();
    const [mount, setMount] = useState({ flag: false, data: [] });
    const [selectedItem, setSelectedItem] = useState<any>([]);
    const [isSaveMiningCartPopup, setSaveMiningCartPopup] = useState<boolean>(false);
    const [isShareMiningCartPopup, setShareMiningCartPopup] = useState<boolean>(false);
    const [saveCartResMining, setSaveCartResMining] = useState({ loading: false, data: {} });
    const [showMiningAlert, setShowMiningAlert] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<string>('');
    const [errorSuccessMessageMining, setErrorSuccessMessageMining] = useState<string>("");
    const [deletePartsResponse, setDeletePartsResponse] = useState<any>({ loading: false, data: {} });
    const { miningParts } = props;

    const {
        headercurrentuser,
        globalData
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            globalData: globalDataSelector.globaldata(state),
        })
    );

    useEffect(() => {
        props?.getMiningParts();
    }, []);

    const showErrorMessageMining = (message: any, type: string) => {
        setErrorSuccessMessageMining(message);
        setAlertType(type);
        setShowMiningAlert(true);
    }

    const gridRef = React.createRef<any>();

    const getSelectedData = () => {
        return selectedItem?.length > 0 ? selectedItem : miningParts?.data;
    };

    const getFilteredData = () => {
        return gridRef.current?.data ?? miningParts?.data;
    };

    const getCommonRecords = (selectedData: any[], filteredData: any[]) => {
        return filteredData?.filter((item: any) =>
            selectedData.some((selectedItem: any) => selectedItem?.miningCartId === item?.miningCartId)
        );
    };

    const excelExport = () => {
        const selectedData = getSelectedData();
        const filteredData = getFilteredData();
        const commonRecords = getCommonRecords(selectedData, filteredData);
        const exportData = commonRecords?.length ? commonRecords : filteredData;
    
        setMount({ flag: true, data: exportData });
    };

    const getSelectedValue = (data: any) => {
        setSelectedItem(data);
    }

    const columns = [
        {
            field: "partNumber",
            title: t(RESOURCE.MyK_Grid_Part_Number),
            filterable: true,
            sortable: true,
            columnMenu: 'ColumnMenu',
        },
        {
            field: "description",
            title: t(RESOURCE.MyK_Label_Description),
            filterable: true,
            sortable: true,
            columnMenu: 'ColumnMenu',
            width: 300
        },
        {
            field: "quantity",
            title: t(RESOURCE.MyK_Grid_Quantity),
            filterable: true,
            sortable: true,
            filter: 'numeric',
            columnMenu: 'ColumnMenu',
        },
    ]

    const ExportDataColumn = new Array();

    columns.forEach((field: any) => (
        field.field !== 'select') && ExportDataColumn.push(
            {
                title: field?.title,
                field: field?.field,
                width: field?.width || 150,
            }
        )
    )
    const isDisabled = (miningParts?.data?.length ?? 0) == 0;

    const getHeaderButtonClass = () => {
        return `custom_lineBtn ${isDisabled ? "disabled" : ""}`;
    };

    const showSaveMiningCart = () => {
        setSaveMiningCartPopup(!isSaveMiningCartPopup);
    };

    const saveMiningCartService = async (saveCartDetails: any) => {
        try {
            const selectedData = selectedItem?.length > 0 ? selectedItem : miningParts?.data;
            const checkedPartNumbers = selectedData?.map((item: any) => item.partNumber) ?? [];
            const miningCartIds = selectedData?.map((item: any) => item.miningCartId) ?? [];
            setSaveCartResMining({ loading: true, data: [] });
            const partNumber: any = checkedPartNumbers.join(',') ?? "";
            const reqBody = {
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                listType: saveCartDetails?.selectedListType ?? '',
                listName: saveCartDetails?.shoppingListName ?? '',
                userAadId: headercurrentuser?.azureADId ?? '',
                partsNo: partNumber,
                miningCartIds: miningCartIds.join(',') ?? ""
            };
            partsService.saveCartList(reqBody).then((response: any) => {
                setSaveCartResMining({ loading: false, data: response ?? {} });
                if (response?.isSuccessful) {
                    props.getPartsListItems();
                    showErrorMessageMining(t(RESOURCE.MyK_Label_ShoppingCart_Cart_Save_Success_Msg), 'success')
                } else {
                    showErrorMessageMining(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Cart_Save_Error_Msg), 'error')
                }
            }).catch(() => {
                setSaveCartResMining({ loading: false, data: [] });
                showErrorMessageMining(`${t(RESOURCE.MyK_Label_ShoppingCart_Cart_Save_Error_Msg)}`, 'error');
            })
        } catch (error) {
            setSaveCartResMining({ loading: false, data: [] });
            showErrorMessageMining(`${t(RESOURCE.MyK_Label_ShoppingCart_Cart_Save_Error_Msg)}`, 'error');
        }
    };

    const onSaveMiningCartChange = (saveInfo: any) => {
        showSaveMiningCart();
        saveMiningCartService(saveInfo);
    };

    const hideSavePopup = () => {
        setSaveMiningCartPopup(false);
    }

    const shareMiningCart = () => {
        if (selectedItem?.length == 0 && !isShareMiningCartPopup) {
            showErrorMessageMining(t(RESOURCE.MyK_Label_ShoppingCart_Share_Validation), 'error');
        } else {
            setShareMiningCartPopup(!isShareMiningCartPopup);
        }
    };

    const deleteMiningPartNumbers = () => {
        setDeletePartsResponse({ loading: true, data: {} });
        const miningCartIds = selectedItem?.map((item: any) => item.miningCartId) ?? []
        const reqBody = {
            "miningCartIds": miningCartIds?.join(',') ?? '',
            "userAadId": headercurrentuser?.azureADId ?? '',
        }
        partsService.deleteMiningPartNumbers(reqBody)
            .then((response: any) => {
                setDeletePartsResponse({ loading: false, data: response });
                if (response.isSuccess) {
                    showErrorMessageMining(response?.message || t(RESOURCE.Myk_Label_ItemsDeletedSuccessfully), 'success')
                    props?.getMiningParts();
                }
                else {
                    showErrorMessageMining(response?.message || t(RESOURCE.MyK_HealthLabel_Deleted_Error_Message), 'error')
                }
            })
            .catch((e: any) => {
                setDeletePartsResponse({ loading: false, data: {} });
                showErrorMessageMining(t(RESOURCE.MyK_HealthLabel_Deleted_Error_Message), 'error')
            });
    }

    const onDeleteMiningParts = () => {
        if (!selectedItem?.length) {
            showErrorMessageMining(t(RESOURCE.MyK_Label_ShoppingCart_Delete_Validation), 'error');
        }
        else {
            const confimObject = {
                title: t(RESOURCE.MyK_Label_SC_Delete_Confirmation),
                message: t(RESOURCE.MyK_Label_SC_Delete_Msg),
                confirmmessage: '',
                buttonLabel: {
                    yes: t(RESOURCE.MyK_Label_Yes),
                    no: t(RESOURCE.MyK_Label_No),
                },
                yesOnclick: () => {
                    deleteMiningPartNumbers();
                },
                noOnclick: () => {
                },
            }
            confirmDailog(confimObject);
        }
    }

    const isLoaderVisible = () => {
        return (miningParts?.loading || saveCartResMining?.loading || deletePartsResponse?.loading || props?.miningDistributorInfo?.loading) && <span className="scLoader"><Loader /></span>
    }

    const handleMiningErrorClose = () => {
        setErrorSuccessMessageMining('');
        setShowMiningAlert(false);
    };

    useEffect(() => {
        if ((miningParts?.data?.length ?? 0) == 0) {
            setErrorSuccessMessageMining("");
            setShowMiningAlert(false);
        }
    }, [miningParts?.data])

    return (
        miningParts?.data?.length > 0 ? <div className="maningPartlistsWrapper mt-4">
            <div className="maningPartlists_title">
                <span>{t(RESOURCE.Myk_Label_Mining_PartsLists)}</span>
            </div>
            <div className="maningPartlists_right">
                <SecondaryButton className={getHeaderButtonClass()} text={t(RESOURCE.MyK_Label_ShoppingCart_Download)} onClick={excelExport} />
                <SecondaryButton className={getHeaderButtonClass()} text={t(RESOURCE.MyK_Label_Save)} onClick={showSaveMiningCart} />
                <SecondaryButton className={getHeaderButtonClass()} text={t(RESOURCE.MyK_Label_Share)} onClick={shareMiningCart} />
                <SecondaryButton className={getHeaderButtonClass()} text={t(RESOURCE.MyK_Label_Delete)} onClick={onDeleteMiningParts} />
            </div>
            {isLoaderVisible()}
            <div className='miningPartsList_Container clearfix'>
            {props?.miningDistributorInfo?.data.hasOwnProperty('email') && props?.getMiningPartsErrMsg(props?.miningDistributorInfo?.data)}
                {showMiningAlert && (
                    <Alerts
                        messageAlert={errorSuccessMessageMining}
                        alertType={alertType}
                        time={30000}
                        onClose={() => {
                            handleMiningErrorClose();
                        }}
                    />
                )}
                <DataTable getSelectedValue={getSelectedValue} selection data={miningParts?.data} dataColumn={columns} dataItemKey='miningCartId' exportRef={gridRef} />
                {mount?.flag && <ExportexcelComp data={mount?.data} setMount={setMount} exportColumn={ExportDataColumn} ExportFileName={'Mining_PartsList_'} />}
            </div>

            {isSaveMiningCartPopup && <SaveCartPopUp
                SaveOnClick={(saveInfo: any) => onSaveMiningCartChange(saveInfo)}
                closePopup={hideSavePopup}
                isQuote={false}
            />
            }
            {
                isShareMiningCartPopup &&
                <ModalPopup
                    ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Share)}
                    ModalPopupType="large"
                    closeModalPopup={shareMiningCart}>
                    <SharePartList mininingCartData={selectedItem} shareOnClick={shareMiningCart} isMiningCart={true} />
                </ModalPopup>
            }
        </div> : null
    )
}

export default MiningPartsLists;